const numberJPScreen = (number) => {
    // case number string => number
    if (typeof number === 'string' && number === '') return '';
    if (typeof number === 'string') number = +number;
    if (typeof number !== 'number') return;
    // case number === 0
    return number !== 0
        ? Intl.NumberFormat('ja-JP', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 20
          }).format(number)
        : 0;
};

const roundNumberInt = (number) => {
    // Round real numbers to the nearest integer
    return number ? Math.round(number) : null;
};

const toNumber = (number) => {
    // case number string => number
    if (typeof number === 'string' && number === '') return '';
    if (typeof number === 'string') number = +number;
    if (typeof number !== 'number') return;
    // case number === 0
    return number !== 0 ? number : 0;
};

export default { numberJPScreen, roundNumberInt, toNumber };
